import React from 'react';
import { FormattedNumber, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import omit from 'lodash/omit';
import orderBy from 'lodash/orderBy';
import toPairs from 'lodash/toPairs';
import sum from 'lodash/sum';

import Grid from '../../components/Grid';
import Progress from '../../components/Progress';
import RatingDisplayOnly from '../../components/RatingDisplayOnly';

import './styles.css';
import messages from './messages';

const starRange = range(5, 0, -1);

class RatingsOverview extends React.PureComponent {
  static propTypes = {
    ratings: PropTypes.object,
  };

  render() {
    const { userList, overview: { averageRating, numRatings, numComments, negativeFeedback }, overview } = this.props.ratings;
    const numStars = (i) => overview[`num${i}stars`];
    const negativeFeedbackPairs = orderBy(toPairs(omit(negativeFeedback, '__typename')), ([, v]) => v, ['desc']);
    const negativeFeedbackSum = sum(negativeFeedbackPairs.map(([, v]) => v));

    return (
      <div className="rep-visits-ratings">
        <Grid columns={3}>
          <Grid.Row>
            <Grid.Column data-cy="repvisits-overall-feedback" tabIndex="0">
              <h2 styleName="section-title">
                <FormattedMessage {...messages.overallFeedback} />
              </h2>
              <div styleName="overall-rating">
                <FormattedNumber
                  value={averageRating}
                  minimumFractionDigits={1}
                  maximumFractionDigits={1}
                />
                <RatingDisplayOnly rating={averageRating} maxRating={5} />
              </div>
              <div>
                <FormattedMessage
                  {...messages.staffMembers}
                  values={{
                    itemCount: <b>{userList.length}</b>,
                    members: (
                      <FormattedMessage
                        {...messages.membersCount}
                        values={{
                          count: userList.length,
                        }}
                      />
                    ),
                  }}
                />
              </div>
              <div>
                <b>{numRatings} </b>
                <FormattedMessage
                  {...messages.visitsCount}
                  values={{
                    count: numRatings,
                  }}
                />
              </div>
              <div>
                <b>{numComments} </b>
                <FormattedMessage
                  {...messages.commentsCount}
                  values={{
                    numComments,
                  }}
                />
              </div>
            </Grid.Column>
            <Grid.Column tabIndex="0">
              <h2 styleName="section-title">
                <FormattedMessage {...messages.feedbackBreakdown} />
              </h2>
              <Grid as="ul" className="stars" columns="equal">
                {starRange.map((i) => {
                  const starsCount = numStars(i);
                  return (
                    <Grid.Row data-cy="repvisits-feedback-stars" as="li" key={i}>
                      <Grid.Column verticalAlign="middle">
                        <span styleName="light-label">
                          <FormattedMessage
                            {...messages.starsCount}
                            values={{
                              stars: i,
                            }}
                          />
                        </span>
                      </Grid.Column>
                      <Grid.Column width={8}>
                        <Progress value={starsCount} total={numRatings} size="small" />
                      </Grid.Column>
                      <Grid.Column textAlign="right" verticalAlign="middle">
                        {/* eslint-disable-next-line react/style-prop-object */}
                        <FormattedNumber value={starsCount / numRatings} style="percent" />
                      </Grid.Column>
                    </Grid.Row>
                  );
                })}
              </Grid>
            </Grid.Column>
            <Grid.Column tabIndex="0">
              <h2 styleName="section-title">
                <FormattedMessage {...messages.topAreasToImprove} />
              </h2>
              <ul styleName="page-row">
                {negativeFeedbackPairs.map(([key, value]) => (
                  <li data-cy="repvisits-feedback-area-to-improve-row" styleName="improvement-area-row" key={key}>
                    <span
                      data-cy="repvisits-feedback-area-to-improve"
                      styleName="improvement-area-label"
                    ><FormattedMessage {...messages[key]} />
                    </span>
                    <span data-cy="repvisits-feedback-area-to-improve-percent" styleName="light-label">
                      {/* eslint-disable-next-line react/style-prop-object */}
                      <FormattedNumber value={negativeFeedbackSum ? (value / negativeFeedbackSum) : 0} style="percent" />
                    </span>
                  </li>
                ))}
              </ul>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>

    );
  }
}

export default RatingsOverview;
